import { render, staticRenderFns } from "./MonitorSection.vue?vue&type=template&id=fb682c12"
import script from "./MonitorSection.vue?vue&type=script&lang=js"
export * from "./MonitorSection.vue?vue&type=script&lang=js"
import style0 from "./MonitorSection.vue?vue&type=style&index=0&id=fb682c12&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports